module.exports = __webpack_public_path__ + "img/ddwu_gallery14.0dc345f3.jpg";